module.exports = __webpack_public_path__ + "media/images/front/icon_mypage-f8724a63682606cfa8508351f6d812f5.png";